/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Recurrenceinterval1Inputs */

const en_entity_recurrenceinterval1 = /** @type {(inputs: Entity_Recurrenceinterval1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurrence Interval`)
};

const de_entity_recurrenceinterval1 = /** @type {(inputs: Entity_Recurrenceinterval1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholungsintervall`)
};

/**
* | output |
* | --- |
* | "Recurrence Interval" |
*
* @param {Entity_Recurrenceinterval1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_recurrenceinterval1 = /** @type {((inputs?: Entity_Recurrenceinterval1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Recurrenceinterval1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_recurrenceinterval1(inputs)
	return de_entity_recurrenceinterval1(inputs)
});
export { entity_recurrenceinterval1 as "entity_recurrenceInterval" }